import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {alertActions} from "../../store/actions/alertActions";
import {Alert, Portal, Snackbar} from "@mui/material";

export function CustomSnackbar({message, clear, severity = "error", timeout = 2500}) {
    const [open, setOpen] = useState(Boolean(message));
    const alertSeverity = ['error', 'warning', 'info', 'success', 'primary'].includes(severity) ? severity : 'error';

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
        clear();
    };

    useEffect(() => {
        setOpen(Boolean(message));
    }, [message, severity]);

    return (
        <Portal>
            <Snackbar
                key={`${alertSeverity}:${message}`}
                autoHideDuration={timeout}
                open={open}
                onClose={handleClose}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                sx={{zIndex: theme => theme.zIndex.tooltip + 1, bottom: {xs: 'calc(16px + env(safe-area-inset-bottom))', sm: 24},
                    maxWidth: {sm: 'calc(100vw - 48px)'}}}
            >
                <Alert onClose={handleClose} variant="filled" severity={alertSeverity}
                    sx={theme => {
                        const background = theme.palette[alertSeverity].dark;
                        return {
                            bgcolor: background, color: theme.palette.getContrastText(background),
                            border: '1px solid', borderColor: theme.palette[alertSeverity].main,
                            borderRadius: '10px', width: '100%', alignItems: 'center',
                            '& .MuiAlert-icon': {color: 'inherit', opacity: 1},
                            '& .MuiAlert-message': {whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 14},
                            '& .MuiAlert-action': {color: 'inherit'}
                        };
                    }}>
                    {message}
                </Alert>
            </Snackbar>
        </Portal>
    );
}

export default connect(null, {clear: alertActions.clear})(CustomSnackbar);
